<template>
  <div id="app" style="padding-top: 70px;">
    <div data-v-f72f4208="" class="layout">
      <div data-v-2b6ea562="" data-v-f72f4208="" class="sticky">
        <div class="logo" style="width: 90px;height: 30px;background-image: url('./static/logo.png');background-size: 100% 100%;
                              margin-right: 50px;position: absolute;top:22px;left: 10px;">
        </div>
        <div data-v-2b6ea562="" class="top-mask">
          <header data-v-2b6ea562="" class="top container">
            <div data-v-2b6ea562="" class="left">
              <a data-v-2b6ea562="" href="javascript:void();" class="router-link-active">
                <!-- <img data-v-2b6ea562="" src="static/picture/top-logo.35d8ab5d.png" -->
                <!-- alt="" class="top-logo"> -->
              </a>
            </div>
          </header>
        </div>
        <div data-v-4c6d260d="" data-v-2b6ea562="" class="overlay" style="z-index: 99999; display: none;">
          <div data-v-2b6ea562="" class="wrapper">
            <!---->
          </div>
        </div>
      </div>
      <div data-v-f72f4208="" class="main-content">
        <div data-v-5bf5284a="" data-v-f72f4208="" class="p-detail">
          <main data-v-5bf5284a="" class="container">
            <div data-v-5bf5284a="" class="m-left">
              <div data-v-5bf5284a="" class="photos">
                <div data-v-5bf5284a="" class="top-title-box">
                  <div data-v-5bf5284a="" class="title">
                    <div data-v-5bf5284a="">
                      <!-- <font id="tp1">气定神闲</font> -->
                    </div>
                    <!-- <div data-v-5bf5284a="" class="handle">
												<div data-v-5bf5284a="" class="zan handle-item">
													<img data-v-5bf5284a=""
														src="data:image/png;base64,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"
														alt="" class="img pointer">
													<div data-v-5bf5284a="" class="pointer">
														0
													</div>
												</div>
												<div data-v-5bf5284a="" class="protect handle-item">
													<img data-v-5bf5284a=""
														src="data:image/png;base64,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"
														alt="" class="img pointer">
												</div>
											</div> -->
                  </div>
                  <!-- <div data-v-5bf5284a="" class="user-box">
										<div data-v-5bf5284a="" class="h5-qrcode">
											<img data-v-5bf5284a="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTCslHiMZFiMZFiMZFyMZFyQZFisgFiMZFyUdFiMZFiMZFiQZFiUZFiMbFyMZFiUZFyMZFo2B/64AAAARdFJOUwAM9LCXo6IXgCKO2E9ZQMBuAqZziQAAAKBJREFUGNNl0FkCgzAIBNAhGyGuuf9lhRCrbecLnwmCOPoIS89Iowwr+h/2qrjk5cEYHSOaIrfNUF/6yWYnoVFMxdF7cjzfPe8PlQfZA0PymiAiDBbZFWGFCNn1hmi3DBe/nnPecJYSB1Z9zCvuyMCZ5CHDLaU28GekoC32D+oYE313sp1BhBbCjYeU+Zc8X2u+MLyxzt3XOkJUdeZ91HwB9JQOhqfpUvsAAAAASUVORK5CYII="
											alt="" class="icon">
											<span data-v-5bf5284a="">
												微信扫码
											</span>
											<div data-v-5bf5284a="" class="qrcode-box" style="display: none;">
												<div data-v-5bf5284a="" class="qrcode-title">
													微信扫码,体验更佳哦~
												</div>
												<img data-v-5bf5284a="" src="static/picture/0231f477a097436695c0feba99773675.jpg"
												alt="" class="qrcode-img">
												<div data-v-5bf5284a="" class="close pointer">
													收起 
													<i data-v-5bf5284a="" class="el-icon-arrow-up"></i>
												</div>
											</div>
										</div>
									</div> -->
                </div>
                <div class="imgBox">
                  <img :src="currentImg" alt="">
                </div>
                <div data-v-5bf5284a="" slot="button-prev" class="swiper-button-prev" tabindex="0" role="button"
                  aria-label="Previous slide"></div>
                <div data-v-5bf5284a="" slot="button-next" class="swiper-button-next" tabindex="0" role="button"
                  aria-label="Next slide"></div>
                <div data-v-5bf5284a="" class="describe text-line-1"></div>
              </div>
            </div>
            
          </main>
        </div>
      </div>
      <!---->
      <div id="logindiv" data-v-4c6d260d="" data-v-366c2a5c="" data-v-f72f4208="" class="overlay"
        style="z-index: 99;display:none">
        <div data-v-366c2a5c="" class="wrapper" style="height: 561px;">
          <i data-v-366c2a5c="" class="el-icon-circle-close icon-close" onclick="loginclose()"></i>
          <div data-v-366c2a5c="">
            <div data-v-366c2a5c="" class="switch">

            </div>
            <div data-v-366c2a5c="" class="desc">
              登录
            </div>
            <div data-v-366c2a5c="" class="login">
              <div data-v-366c2a5c="" class="left">
                <div data-v-366c2a5c="" class="select">
                  <div data-v-366c2a5c="" class="btn active pointer">
                    密码登录
                  </div>
                </div>
                <div data-v-366c2a5c="" class="psdform">
                  <form data-v-366c2a5c="" class="el-form psdform form">
                    <div data-v-366c2a5c="" class="el-form-item">
                      <!---->
                      <div class="el-form-item__content">
                        <div data-v-366c2a5c="" class="el-input">
                          <!---->
                          <input id="username" type="text" autocomplete="off" placeholder="请输入您的账号" required="required"
                            class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                        <!---->
                      </div>
                    </div>
                    <div data-v-366c2a5c="" class="el-form-item">
                      <!---->
                      <div class="el-form-item__content">
                        <div data-v-366c2a5c="" class="el-input">
                          <!---->
                          <input id="password" type="password" autocomplete="off" placeholder="请输入您的密码"
                            class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                        <!---->
                      </div>
                    </div>
                    <div data-v-366c2a5c="" style="text-align: right; margin-top: -10px;">

                    </div>
                    <div data-v-366c2a5c="" class="el-form-item btns">
                      <!---->
                      <div class="el-form-item__content">
                        <button data-v-366c2a5c="" type="button" class="el-button el-button--primary" onclick="login()">
                          <!---->
                          <!---->
                          <span>
                            登录
                          </span>
                        </button>
                        <!---->
                      </div>
                    </div>
                  </form>
                </div>
                <div data-v-366c2a5c="" class="reg">
                  暂无账号，去申请
                  <i data-v-366c2a5c="" class="pointer" onclick="goreg()">
                    注册
                  </i>
                </div>
              </div>
              <!---->
            </div>
          </div>
          <!---->
        </div>
      </div>

      <div id="regdiv" data-v-4c6d260d="" data-v-366c2a5c="" data-v-f72f4208="" class="overlay"
        style="z-index: 99;display:none">
        <div data-v-366c2a5c="" class="wrapper" style="height: 561px;">
          <i data-v-366c2a5c="" class="el-icon-circle-close icon-close" onclick="regclose()"></i>
          <div data-v-366c2a5c="">
            <div data-v-366c2a5c="" class="switch">

            </div>
            <div data-v-366c2a5c="" class="desc">
              注册
            </div>
            <div data-v-366c2a5c="" class="login">
              <div data-v-366c2a5c="" class="left">

                <div data-v-366c2a5c="" class="psdform">
                  <form data-v-366c2a5c="" class="el-form psdform form">
                    <div data-v-366c2a5c="" class="el-form-item">
                      <!---->
                      <div class="el-form-item__content">
                        <div data-v-366c2a5c="" class="el-input">
                          <!---->
                          <input id="nickname" type="text" autocomplete="off" placeholder="请输入您的昵称" required="required"
                            class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                        <!---->
                      </div>
                    </div>
                    <div data-v-366c2a5c="" class="el-form-item">
                      <!---->
                      <div class="el-form-item__content">
                        <div data-v-366c2a5c="" class="el-input">
                          <!---->
                          <input id="username2" type="text" autocomplete="off" placeholder="请输入您的账号"
                            class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                        <!---->
                      </div>
                    </div>

                    <div data-v-366c2a5c="" class="el-form-item">
                      <!---->
                      <div class="el-form-item__content">
                        <div data-v-366c2a5c="" class="el-input">
                          <!---->
                          <input id="password2" type="password" autocomplete="off" placeholder="请输入您的密码"
                            class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                        <!---->
                      </div>
                    </div>
                    <div data-v-366c2a5c="" style="text-align: right; margin-top: -10px;">
                      <span data-v-366c2a5c=""
                        style="cursor: pointer; color: rgb(204, 62, 53); font-weight: 500; font-size: 14px;">
                        <!-- 忘记密码 -->
                      </span>
                    </div>
                    <div data-v-366c2a5c="" class="el-form-item btns">
                      <!---->
                      <div class="el-form-item__content">
                        <button data-v-366c2a5c="" type="button" class="el-button el-button--primary" onclick="reg()">
                          <!---->
                          <!---->
                          <span>
                            注册
                          </span>
                        </button>
                        <!---->
                      </div>
                    </div>
                  </form>
                </div>
                <div data-v-366c2a5c="" class="reg">
                  已有账号，去登录
                  <i data-v-366c2a5c="" class="pointer" onclick="logindiv()">
                    登录
                  </i>
                </div>
              </div>
              <!---->
            </div>
          </div>
          <!---->
        </div>
      </div>

    </div>
    <!---->
    <!---->
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentImg:""
    }
  },
  created(){
    // console.log(this.$route.query.src);
    this.currentImg = this.$route.query.src
    
  }
}
</script>

<style lang="scss" scoped>
/* 引入外部 CSS 文件 */
@import '../assets/css/chunk-commons.2621a319.css';
.container{
  display: flex;
  justify-content: center;
}
.imgBox{
  width: 759px;
  height: 800px;
  img{
    width: 100%;
    height: 100%;
  }
}
.requirement[data-v-d0ea3bbc] {
  background-color: #fff;
  border-radius: 3px;
  padding: 50px 60px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between
}

.divider[data-v-d0ea3bbc] {
  width: 1px;
  height: 248px;
  background-color: #dedede;
  margin: 0 40px;
  margin-top: 40px
}

.requirement-item .img[data-v-d0ea3bbc] {
  width: 166px;
  height: 141px;
  margin: 0 auto;
  text-align: center
}

.requirement-item .title[data-v-d0ea3bbc] {
  font-size: 18px;
  padding-top: 28px;
  padding-bottom: 8px;
  text-align: center
}

.requirement-item .desc[data-v-d0ea3bbc] {
  text-align: center;
  color: #999;
  padding-bottom: 30px;
  font-size: 12px
}

.requirement-item .list[data-v-d0ea3bbc] {
  padding-bottom: 40px
}

.requirement-item .list-item[data-v-d0ea3bbc] {
  padding-bottom: 3px;
  padding-top: 3px;
  font-size: 14px;
  padding-left: 15px;
  position: relative
}

.requirement-item .list-item[data-v-d0ea3bbc]:after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 5px;
  height: 5px;
  background: #e05c49;
  border-radius: 10px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%)
}

.tip[data-v-d0ea3bbc] {
  text-align: center;
  font-size: 12px;
  color: #e05c49;
  position: absolute;
  top: -26px;
  width: 100%;
  cursor: pointer
}

.publish-btn-box[data-v-d0ea3bbc] {
  position: relative
}

.p-detail[data-v-5bf5284a] {
  width: 100%;
  padding-top: 10px;
  background: #f9fafc
}

main[data-v-5bf5284a] {
  display: -webkit-flex;
  display: flex
}

main .m-left[data-v-5bf5284a] {
  width: 72%;
  margin-right: 10px
}

main .m-left .photos[data-v-5bf5284a] {
  position: relative;
  background-color: #fff;
  margin-bottom: 20px;
  padding: 20px;
  box-shadow: 0 5px 10px 0 hsla(0, 0%, 73.3%, .5)
}

main .m-left .photos .top-title-box[data-v-5bf5284a] {
  -webkit-justify-content: space-between;
  justify-content: space-between
}

main .m-left .photos .top-title-box .title[data-v-5bf5284a],
main .m-left .photos .top-title-box[data-v-5bf5284a],
main .m-left .photos .user-box .h5-qrcode[data-v-5bf5284a],
main .m-left .photos .user-box[data-v-5bf5284a] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center
}

main .m-left .photos .user-box .h5-qrcode[data-v-5bf5284a] {
  width: 160px;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  cursor: pointer
}

main .m-left .photos .user-box .h5-qrcode .icon[data-v-5bf5284a] {
  width: 15px;
  margin-right: 5px
}

main .m-left .photos .qrcode-box[data-v-5bf5284a] {
  background-color: rgba(0, 0, 0, .5);
  color: #fff;
  padding: 20px 0;
  padding-bottom: 5px;
  text-align: center;
  position: absolute;
  top: 58px;
  z-index: 10;
  font-size: 14px
}

main .m-left .photos .qrcode-box .qrcode-title[data-v-5bf5284a] {
  padding-bottom: 15px
}

main .m-left .photos .qrcode-box .qrcode-img[data-v-5bf5284a] {
  width: 120px;
  margin: 0 20px
}

main .m-left .photos .qrcode-box .close[data-v-5bf5284a] {
  padding-top: 5px;
  border-top: 1px solid #fff;
  margin-top: 10px
}

main .m-left .photos .verticle-line[data-v-5bf5284a] {
  padding: 10px;
  color: #666
}

main .m-left .photos .title[data-v-5bf5284a] {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 11px;
  letter-spacing: 1px
}

main .m-left .photos .describe[data-v-5bf5284a] {
  font-size: 14px;
  color: #333;
  margin: 15px 0
}

main .m-left .photos img[data-v-5bf5284a] {
  width: 100%
}

main .m-left .m-comment[data-v-5bf5284a] {
  width: 100%;
  padding: 40px 60px 100px;
  background-color: #fff
}

main .m-right[data-v-5bf5284a] {
  width: 28%
}

.m-right .m-photo-list[data-v-5bf5284a] {
  max-height: 450px;
  overflow-y: scroll;
  padding-bottom: 10px
}

.m-right .m-photo-list .user[data-v-5bf5284a] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 14px
}

.m-right .m-photo-list .user img[data-v-5bf5284a] {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  background-color: #333;
  margin-right: 10px;
  -o-object-fit: cover;
  object-fit: cover
}

.m-right .m-photo-list .user .user-name[data-v-5bf5284a] {
  -webkit-flex: 1;
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: #333
}

.m-right .m-photo-list[data-v-5bf5284a]::-webkit-scrollbar {
  width: 5px;
  height: 30px
}

.m-right .m-photo-list[data-v-5bf5284a]::-webkit-scrollbar-track {
  border-radius: 7px;
  box-shadow: inset 0 0 6px hsla(0, 0%, 100%, .3);
  background-color: #fff
}

.m-right .m-photo-list[data-v-5bf5284a]::-webkit-scrollbar-track:hover {
  border-radius: 7px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #7f7f7f
}

.m-right .photo-list[data-v-5bf5284a] {
  margin-bottom: 10px;
  padding: 20px 10px;
  background-color: #fff;
  box-shadow: 0 5px 10px 0 hsla(0, 0%, 73.3%, .5)
}

.m-right .photo-list .title[data-v-5bf5284a] {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  letter-spacing: 1px;
  margin-bottom: 11px
}

.m-right .photo-list .list .list-item[data-v-5bf5284a] {
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
  cursor: pointer
}

.m-right .photo-list .list .list-item .img[data-v-5bf5284a] {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 100%;
  margin: 0 auto;
  margin-bottom: 5px
}

.m-right .photo-list .list .list-item .img img[data-v-5bf5284a] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover
}

.m-right .photo-list .detail[data-v-5bf5284a] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  font-size: 12px;
  margin-bottom: 10px
}

.m-right .photo-list .detail .time[data-v-5bf5284a] {
  -webkit-flex: 1;
  flex: 1;
  color: #999
}

.m-right .photo-list .detail .hot[data-v-5bf5284a] {
  -webkit-flex: 1;
  flex: 1;
  text-align: right;
  color: #e05c49
}

.m-right .photo-list .detail .hot img[data-v-5bf5284a] {
  width: 11px;
  margin-right: 3px;
  vertical-align: top
}

.m-right[data-v-5bf5284a] .el-avatar>img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover
}

.m-right .visitor[data-v-5bf5284a] {
  box-shadow: 0 5px 10px 0 hsla(0, 0%, 73.3%, .5)
}

.m-right .visitor .list .list-item .avatar[data-v-5bf5284a] {
  position: relative;
  width: 80%;
  height: 0;
  margin: 0 auto;
  padding-top: 80%
}

.m-right .visitor .list .list-item .avatar .img[data-v-5bf5284a] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -o-object-fit: cover;
  object-fit: cover
}

.m-right .visitor .list .list-item .name[data-v-5bf5284a] {
  height: 18px;
  margin-top: 3px;
  font-size: 13px;
  color: #333
}

.m-right .visitor .list .list-item .time[data-v-5bf5284a] {
  font-size: 11px;
  color: #999
}

.swiper[data-v-5bf5284a] {
  width: 100%
}

.swiper img[data-v-5bf5284a] {
  width: 100%;
  -o-object-fit: cover;
  object-fit: cover
}

.swiper-button-next[data-v-5bf5284a],
.swiper-button-prev[data-v-5bf5284a] {
  color: #999;
  font-weight: 900
}

.swiper-button-prev[data-v-5bf5284a],
.swiper-container-rtl .swiper-button-next[data-v-5bf5284a] {
  position: fixed;
  left: 22px
}

.swiper-button-next[data-v-5bf5284a],
.swiper-container-rtl .swiper-button-prev[data-v-5bf5284a] {
  position: fixed;
  right: 40px
}

.handle[data-v-5bf5284a] {
  display: -webkit-flex;
  display: flex;
  font-size: 13px;
  color: #999;
  margin-left: 10px;
  margin-top: 3px
}

.handle .handle-item[data-v-5bf5284a] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center
}

.handle .handle-item .img[data-v-5bf5284a] {
  width: 18px;
  margin-right: 8px;
  vertical-align: middle
}

.handle .handle-item div[data-v-5bf5284a] {
  margin-right: 15px
}

.tabs-box[data-v-11e51d3e] {
  -webkit-justify-content: space-between;
  justify-content: space-between;
  height: 28px
}

.tabs-box[data-v-11e51d3e],
.tabs[data-v-11e51d3e] {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center
}

.tabs[data-v-11e51d3e] {
  color: #999
}

.tab-item[data-v-11e51d3e] {
  font-size: 14px;
  margin-right: 30px;
  position: relative;
  cursor: pointer;
  transition: all .3s
}

.tab-item.active[data-v-11e51d3e] {
  font-size: 16px;
  font-weight: 600;
  color: #333
}

.tab-item.active .borderactive[data-v-11e51d3e] {
  position: absolute;
  right: 6px;
  bottom: -8px;
  width: 70%;
  height: 5px;
  background: #e05c49
}

.tab-item.active1[data-v-11e51d3e] {
  color: #333;
  font-weight: 600
}

.slot[data-v-11e51d3e] {
  margin-left: auto
}









</style>
